import '../styling/admin.css'
import { constants } from '../constants'

const BookingSummaryListItem = ({ user, type }) => {

    return (
        <div className='booking-summary-user-list-item-details'>
            <span className='details-user'>{user.userID}</span>
            <span className='details-number'>{type === constants.balconyType ? user.balconyBookings.length : user.laundryBookings.length}</span>
        </div>
    )
}

export default BookingSummaryListItem